import React from 'react';
import { FormNumber, Fieldset } from '~/components/FormControl';
import { Form, Col } from 'react-bootstrap';

function NumberOfUpgrade() {
    return (
        <Col sm={6}>
            <Fieldset>
                <Fieldset.Legend>Number Of Upgrade:</Fieldset.Legend>
                <Form.Row>
                    <FormNumber
                        name={'numberOfExtraUpgrade'}
                        sm={4}
                    />
                    <FormNumber
                        name={'numberOfLostUpgrade'}
                        sm={4}
                        className={'offset-sm-4'}
                    />
                </Form.Row>
            </Fieldset>
        </Col>
    );
}

export default NumberOfUpgrade;
